import React from 'react'
import { CloseCircle, Edit2 } from 'iconsax-react'
import { useTheme } from '@mui/material'
import { useAppDispatch } from '@SonarCX/hooks/redux'

import AreYouSureModal from '@SonarCX/components/molecules/ChatModals/AreYouSureModal'

import { AddSuccessAlert } from '@SonarCX/slices/alert'
import { useIntegrations } from '@SonarCX/providers/IntegrationProvider'

import useStyles from './styles'

const EditDelete = ({ open, data }) => {
  const theme = useTheme()
  const dispatch = useAppDispatch()

  const { deleteInt } = useIntegrations()

  const [deleteCheck, setDeleteCheck] = React.useState(false)

  const classes = useStyles()

  return (
    <div>
      <Edit2
        size={theme.size.base}
        className={classes.icon}
        onClick={open(data)}
      />
      <CloseCircle
        size={theme.size.base}
        className={classes.icon}
        onClick={() => {
          setDeleteCheck(true)
        }}
      />

      {deleteCheck && (
        <AreYouSureModal
          open={deleteCheck}
          onAccept={() =>
            deleteInt(data.id).then(() => {
              dispatch(AddSuccessAlert('Changes saved'))
              setDeleteCheck(false)
            })
          }
          onClose={() => setDeleteCheck(false)}
          reason={'Are you sure you want to delete this integration'}
          subtext={'Everything using this integration will be affected.'}
        />
      )}
    </div>
  )
}

export default EditDelete
